import { render, staticRenderFns } from "./report-teacher.vue?vue&type=template&id=fcff141e&scoped=true&"
import script from "./report-teacher.vue?vue&type=script&lang=js&"
export * from "./report-teacher.vue?vue&type=script&lang=js&"
import style0 from "./report-teacher.vue?vue&type=style&index=0&id=fcff141e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcff141e",
  null
  
)

export default component.exports